module.exports = __webpack_public_path__ + "static/SquareSerif-Medium-webfont-81bf6e173b687fa57f619c367c08d65a.ttf";